import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import Alpine from 'alpinejs';
import lazyModules from './block-imports/modules';
import { PegasusModule, FrameworkAdaptor } from './PegasusModule';
import { AlpineAdaptor } from './lazy-blocks/adaptors/AlpineAdaptor';

/**
 * Import all JS from the global folder and all compiled global blocks
 */
import.meta.glob('./global/**/*.js', { eager: true });
import.meta.glob(['../../parts/**/*.js', '!../../parts/**/handlers/**'], { eager: true });
import './block-imports/scripts.js';

/**
 * Add FrameworkAdaptor to managed the lazy loading of framework specific modules via the PegasusModule
 */
FrameworkAdaptor.use('alpine', new AlpineAdaptor(Alpine));

/**
 * Register the PegasusModule as a custom element
 */
window.customElements.define('pegasus-module', PegasusModule);

/**
 * Detect if we are in the WordPress block editor (admin).
 * Block previews are rendered asynchronously via ACF server-side rendering,
 * so lazy-loaded Alpine modules won't be available when Alpine processes them.
 */
const isBlockEditor = document.body.classList.contains('wp-admin');

let alpineAdaptor = null;

if (isBlockEditor) {
	/**
	 * In the block editor, eagerly load ALL lazy modules so Alpine has
	 * the real component implementations when ACF block previews render.
	 * Lazy loading / code-splitting is only useful on the frontend.
	 *
	 * We load all modules first, then start Alpine once they're registered.
	 */
	Promise.all(Object.values(lazyModules).map(({ loader }) => loader())).then(() => {
		Alpine.plugin(intersect);
		Alpine.plugin(collapse);
		window.Alpine = Alpine;
		Alpine.start();
	});
} else {
	/**
	 * Initialise the Alpine adaptor for lazy block loading.
	 * Scan for lazy blocks and mark them with x-ignore before Alpine starts.
	 * This prevents Alpine from trying to initialise components that haven't loaded yet.
	 */
	alpineAdaptor = new AlpineAdaptor(Alpine);
	alpineAdaptor.initLazyBlocks(lazyModules);

	Alpine.plugin(intersect);
	Alpine.plugin(collapse);
	window.Alpine = Alpine;
	Alpine.start();

	alpineAdaptor.observeLazyBlocks();
}
